<template>
  <div
    :class="['randomizer-tasklist', {'randomizer-tasklist__finished': randomButtonData.status === RANDOM_BUTTON_STATUS.FINISH}]"
  >
    <template v-if="randomButtonData.status !== RANDOM_BUTTON_STATUS.FINISH">
      <h1 class="heading1" v-html="$c('Выполняй задания, зарабатывай Шансы,%(br)s крути карту и получай ценные награды!', { br: `<br>` })" />
      <div class="randomizer-tasklist_description">
        <span class="grey-text-20">{{ $c('За каждое выполненное задание ты получишь один') }}</span>
        <SpinsIco />
        <span class="red-text-20">{{ $c('Шанс.') }}</span>
        <br />
        <span
          v-if="isParticipant"
          class="grey-text-20"
        >{{ $c('Количество доступных Шансов указано справа под крутящейся картой.') }} </span>
        <span
          v-else
          class="grey-text-20"
        >{{ $c('Используй Шансы, чтобы зарабатывать случайные призы!') }} </span>
      </div>
      <BoundCard v-if="user" class="randomizer-tasklist_bound" />
      <LoginSection v-if="status === DATA_STATUS.NEED_AUTH" />
      <OrderOrBind v-if="status === DATA_STATUS.NEED_PARTICIPATE" />
      <AvailableTasks v-if="status === DATA_STATUS.DATA_READY" />
    </template>
    <template v-else>
      <h1 class="heading1" v-html="$c('Акция «Миссия выполнима: Blitz-квест» завершена.', { br: `<br>` })" />
      <div class="randomizer-tasklist_description">
        <span class="grey-text-20">{{ $c('Успей использовать свои') }}</span>
        <SpinsIco />
        <span class="red-text-20">{{ $c('Шансы.') }}</span>
        <br />
        <span class="grey-text-20">{{$c('Страница квеста будет доступна до 5 ноября 11:59 (МСК).')}}</span>
      </div>
      <BoundCard v-if="user" class="randomizer-tasklist_bound" />
      <p
        class="green"
        v-html="$c(
          'За весь период квеста Шансов получено — %(spinsTotal)s.',
          {finishedTotal, spinsTotal})"
      />
    </template>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import SpinsIco from '@/components/RandomRewards/SpinsIco'
import LoginSection from '@/components/RandomRewards/TaskList/LoginSection'
import OrderOrBind from '@/components/RandomRewards/TaskList/OrderOrBind'
import AvailableTasks from '@/components/RandomRewards/TaskList/AvailableTasks'
import BoundCard from '@/components/RandomRewards/BindCard/BoundCard'

import { RANDOM_REWARDS_DATA_STATUS as DATA_STATUS, RANDOM_BUTTON_STATUS } from '@/constants'
import { namespace, State } from 'vuex-class'
const randomRewards = namespace('randomRewards')
const auth = namespace('auth')

@Component({
  components: {
    SpinsIco,
    LoginSection,
    OrderOrBind,
    AvailableTasks,
    BoundCard
  }
})
class TaskList extends Vue {
  @Prop({
    type: String,
    required: true
  }) status

  @auth.State(({ user }) => user) user

  @randomRewards.State('cardCodeHidden') cardCodeHidden
  @randomRewards.State('finishedTotal') finishedTotal
  @randomRewards.State('spinsTotal') spinsTotal
  @randomRewards.State('isParticipant') isParticipant
  @State('randomButtonData') randomButtonData

  DATA_STATUS = DATA_STATUS
  RANDOM_BUTTON_STATUS = RANDOM_BUTTON_STATUS
}

export default TaskList
</script>

<style lang="scss">
  .randomizer-tasklist {
    display: block;
    width: 100%;
    &__finished {
      align-self: center;
    }
    .green {
      color: #3BB200;
    }
    @include media_desktop {
      width: auto;
    }
    &_description {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      vertical-align: middle;
      padding: 24px 0;
      @include media_desktop {
        padding: 30px 0;
      }
      & > svg {
        vertical-align: middle;
      }
    }
    &_bound {
      body & {
        margin-top: 4px;
        margin-bottom: 24px;
        @include media_desktop {
          margin-top: 20px;
          margin-bottom: 50px;
        }
      }
    }
  }
  %fz20-23 {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    @include media_desktop {
     font-size: 20px;
     line-height: 23px;
    }
  }
  .white-text-20 {
    @extend %fz20-23;
    color: #FFFFFF;
  }
  .grey-text-20 {
    @extend %fz20-23;
    color: #999999;
  }
  .red-text-20 {
    @extend %fz20-23;
    color: #FF002A;
  }
</style>
